import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function ControlsHint({ dismissed, onDismiss }) {
  return (
    <AnimatePresence>
      {!dismissed && (
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 12 }}
          className="pointer-events-auto fixed bottom-6 right-6 z-40 max-w-xs border border-[#01FFFF]/30 bg-black/60 backdrop-blur-md p-4"
          data-testid="game-controls-hint"
        >
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#01FFFF]">
            Navigation
          </p>
          <p className="mt-2 font-mono text-xs leading-relaxed text-[#8A9AAB]">
            <span className="text-[#01FFFF]">W/↑</span> forward,{" "}
            <span className="text-[#01FFFF]">S/↓</span> backward,{" "}
            <span className="text-[#01FFFF]">A/←</span> turn left,{" "}
            <span className="text-[#01FFFF]">D/→</span> turn right. The camera
            trails behind you automatically. Follow the glowing floor path,
            compass and mini-map, and walk through each portal checkpoint to
            explore that section.
          </p>
          <button
            type="button"
            onClick={onDismiss}
            data-testid="dismiss-controls-hint-button"
            className="mt-3 font-mono text-[10px] uppercase tracking-widest text-[#FF007F] hover:text-[#01FFFF]"
          >
            Got it ✕
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
